import React, { useEffect, useRef, useState } from "react";
import DropdownFilterButton from "./DropdownFilterButton";
import DropdownFilterMenu from "./DropdownFilterMenu";

/*
props = {
  uId: <uniqueIdentifier>,
  data: {
    icon: <string>,
    options: [{ value: "value1", label: "Label 1" }, ...],
    selectedLabel: <string>,
    selectedValue: <string>,
  },
  dispatcher: <handler>,
  onSubmit: <handler>
}
*/

const DropDown = (props) => {
  const { uId, data, dispatcher, wrapperClass } = props;
  
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const shouldSubmitRef = useRef(false);
  
  // Use useEffect to trigger onSubmit after state update
  useEffect(() => {
    if (shouldSubmitRef.current) {
      shouldSubmitRef.current = false;
      props.onSubmit?.();
    }
  }, [data.selectedValue]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const onOptionSelect = (selectedValue) => {
    const selectedOption = data.options?.find(option => option.value === selectedValue);
    
    const newData = {
      ...data,
      selectedValue: selectedValue,
      selectedLabel: selectedOption?.label || null
    };
    
    // Update the state
    dispatcher({ uId: uId, data: newData });
    
    // Close dropdown
    setIsOpen(false);
    
    // Mark that we should submit after state update
    shouldSubmitRef.current = true;
  };

  // Get the current value - use selectedValue if available
  const currentValue = data.selectedValue;
  const currentOption = data.options?.find(option => option.value === currentValue);
  const displayLabel = currentOption?.label;

  return (
    <div className={`chr-widget-dropdown-action cui-dropdown-filter d-flex align-items-center ${wrapperClass || ''}`}>
      <div style={{ position: 'relative', flex: 1 }} ref={dropdownRef}>
        <DropdownFilterButton
          isOpen={isOpen}
          displayLabel={displayLabel}
          icon={data.icon}
          disabled={data.disabled}
          className={data.className}
          onClick={() => setIsOpen(!isOpen)}
        />

        {isOpen && (
          <DropdownFilterMenu 
            options={data.options}
            currentValue={currentValue}
            onOptionSelect={onOptionSelect}
          />
        )}
      </div>
    </div>
  );
};

export default DropDown;